import React, { useState } from "react"
import PropTypes from "prop-types"
import api from "helpers/Api"
import { isEmpty } from "lodash"
import moment from "moment"

const MonthWiseTableComponent = ({ data, name, statusPayload, mode, dateFormat }) => {


    const tableStyle = {
        border: "1.5px solid rgb(228, 225, 225)",
        borderCollapse: "collapse",
        borderRadius: "4px",
        marginTop: "20px",
        marginLeft: "20px", // Add left margin
        marginRight: "20px", // Add right margin
        // overflowX: "auto",
    }

    const thStyle = {
        border: "1.5px solid rgb(228, 225, 225)",
        borderCollapse: "collapse",
        backgroundColor: "#f2f3f3",
        padding: "17px",
        fontSize: "14px",
        width: "150px"
    }

    const tdStyle = {
        border: "1.5px solid rgb(228, 225, 225)",
        borderCollapse: "collapse",
        padding: "15px 20px"
    }

    const buttonStyle = {
        backgroundColor: "#E40D8C",
        color: "white",
        border: "none",
        padding: "5px 10px",
        borderRadius: "2px",
        fontSize: "13px",
        cursor: "pointer",
        marginTop: "60px"
    }
    //paging
    const itemsPerPage = 10 // Number of items to display per page
    const [currentPage, setCurrentPage] = useState(1)

    // Calculate the index range for the current page
    const startIndex = (currentPage - 1) * itemsPerPage
    const endIndex = startIndex + itemsPerPage

    // Slice the data array to get the items for the current page
    const currentPageData = data.slice(startIndex, endIndex)

    // Function to handle page changes
    const handlePageChange = (pageNumber) => {
        setCurrentPage(pageNumber)
    }

    ///excel functionality 
    const [isLoading, setIsLoading] = useState(false)
    const totalPages = Math.ceil(data.length / itemsPerPage)
    const displayPages = 5 // Number of pagination buttons to display

    const renderPaginationButtons = () => {
        const buttons = []
        const start = Math.max(1, currentPage - Math.floor(displayPages / 2))
        const end = Math.min(start + displayPages - 1, totalPages)

        for (let i = start; i <= end; i++) {
            buttons.push(
                <button
                    key={i}
                    style={{
                        backgroundColor: currentPage === i ? '#E40D8C' : '#FFFFFF',
                        color: currentPage === i ? 'white' : '#74788D',
                        border: currentPage === i ? '1px solid #E40D8C' : '1px solid #74788D',
                        padding: '5px 10px',
                        marginRight: '5px',
                        cursor: 'pointer'
                    }}
                    onClick={() => handlePageChange(i)}
                    disabled={currentPage === i}
                >
                    {i}
                </button>
            )
        }
        return buttons
    }
    const downloadFile = ({ csvdata, fileName, fileType }) => {
        const blob = new Blob([csvdata], { type: fileType })

        const a = document.createElement("a")
        a.download = fileName
        a.href = window.URL.createObjectURL(blob)
        const clickEvt = new MouseEvent("click", {
            view: window,
            bubbles: true,
            cancelable: true,
        })
        a.dispatchEvent(clickEvt)
        a.remove()
    }
    const downloadCsv = (statusPayload) => {

        setIsLoading(true)
        api
            .post(`/get_CrmWorker_detailed_processStatus_new`, statusPayload)
            .then((response) => {


                const ExportDataTable = response.data.data.length > 0
                    ? response.data.data.map((item, index) => {

                        const allEventsList = !isEmpty(item.allEvents)
                            ? item.allEvents.map((m) => m).join(",")
                            : "--"
                        const allEvents = JSON.stringify(allEventsList).replace(
                            /","/g,

                            "\n"
                        )
                        const eventDateList = item && item.eventDate && item.eventDate.length > 0 ?
                            item.eventDate.map((m) => moment(m).format(dateFormat)).join(",") : "--"
                        const eventDate = JSON.stringify(eventDateList).replace(
                            /","/g,
                            "\n"
                        )


                        const leadNo = mode != 1 &&item && item.leadNo && item.leadNo.length > 0 ?
                            item.leadNo.map(m => m).join(",") : "--"

                        const completedDate = item && item.completedDate && item.completedDate.length > 0 ?
                            item.completedDate.map((m) => moment(m).format(dateFormat)).join(",") : "--"

                        const pendingDelierables = item && item.pendingDelierables && item.pendingDelierables.length > 0 ?
                            item.pendingDelierables.map(m => m).join(",") : "--"

                        const leadNoValue = JSON.stringify(leadNo).replace(
                            /","/g,
                            "\n"
                        )
                        const pendingDelierablesValue = JSON.stringify(pendingDelierables).replace(
                            /","/g,
                            "\n"
                        )
                        const completedDateValue = JSON.stringify(completedDate).replace(
                            /","/g,
                            "\n"
                        )
                        const brideName =  mode != 1 &&item && item.brideName && item.brideName.length > 0 ?
                            item.brideName.map(m => m).join(",") : "--"

                        const groomName =  mode != 1 &&item && item.groomName && item.groomName.length > 0 ?
                            item.groomName.map(m => m).join(",") : "--"

                        const brideNameValue = JSON.stringify(brideName).replace(
                            /","/g,
                            "\n"
                        )
                        const groomNameValue = JSON.stringify(groomName).replace(
                            /","/g,
                            "\n"
                        )
                        return {
                            //common
                            _id: index,
                            sNo: index + 1,
                            leadNoValue: leadNoValue,
                            leadNo: item.leadNo ? item.leadNo : "--",
                            clientCode: item.clientCode ? item.clientCode : "--",
                            groomName: item.groomName ? item.groomName : "--",
                            brideName: item.brideName ? item.brideName : "--",
                            groomNameValue:groomNameValue,
                            brideNameValue:brideNameValue,
                            pendingDeliCount: item.pendingDeliCount ? item.pendingDeliCount : "--",
                            pendingDelierables: pendingDelierablesValue,
                            allEvents: allEvents,
                            eventDate: eventDate,
                            //mode 7
                            clientCompleteDate: completedDateValue


                        }
                    })
                    : []
                setTimeout(() => {
                    let headerData = [
                        `S.No,${mode == 1 ? "Lead No,Client Code,Bride Name,Groom Name,Event Name,Event Date,Pending Deliverable Count, Pending Deliverable List" :
                            mode == 2 || mode == 3 || mode == 4 || mode == 5 || mode == 6 || mode == 7 ? "Client Code,Lead No,Bride Name,Groom Name,Event Name,Event Date,Pending Deliverable Count, Pending Deliverable List" :
                                "Client Code,Lead No,Bride Name,Groom Name,Event Name,Event Date,Pending Deliverable Count, Pending Deliverable List,Client Complete Date"}`
                    ]

                    let usersCsv =

                        ExportDataTable.reduce((acc, user) => {
                            if (mode == 1) {
                                const {
                                    sNo,
                                    leadNo,
                                    clientCode,
                                    brideName,
                                    groomName,
                                    allEvents,
                                    eventDate,
                                    pendingDeliCount,
                                    pendingDelierables

                                } = user
                                acc.push([
                                    sNo,
                                    leadNo,
                                    clientCode,
                                    brideName,
                                    groomName,
                                    allEvents,
                                    eventDate,
                                    pendingDeliCount,
                                    pendingDelierables
                                ])
                            }
                            else if (mode == 2 || mode == 3 || mode == 4 || mode == 5 || mode == 6 || mode == 7) {
                                const {
                                    sNo,
                                    clientCode,
                                    leadNoValue,
                                    brideNameValue,
                                    groomNameValue,
                                    allEvents,
                                    eventDate,
                                    pendingDeliCount,
                                    pendingDelierables
                                } = user
                                acc.push([
                                    sNo,
                                    clientCode,
                                    leadNoValue,
                                    brideNameValue,
                                    groomNameValue,
                                    allEvents,
                                    eventDate,
                                    pendingDeliCount,
                                    pendingDelierables
                                ])
                            } else {
                                const {
                                    sNo,
                                    clientCode,
                                    leadNoValue,
                                    brideNameValue,
                                    groomNameValue,
                                    allEvents,
                                    eventDate,
                                    pendingDeliCount,
                                    pendingDelierables,
                                    clientCompleteDate

                                } = user
                                acc.push([
                                    sNo,
                                    clientCode,
                                    leadNoValue,
                                    brideNameValue,
                                    groomNameValue,
                                    allEvents,
                                    eventDate,
                                    pendingDeliCount,
                                    pendingDelierables,
                                    clientCompleteDate

                                ])
                            }


                            return acc
                        }, [])

                    downloadFile({
                        csvdata: [...headerData, ...usersCsv].join("\n"),
                        fileName: "MonthWisePendingClientCount.csv",
                        fileType: "text/csv",
                    })
                    setIsLoading(false)
                }, 500)
                return response.data

            })
            .catch((error) => {
                setIsLoading(false)
                Promise.reject(error)

            })
    }
    return (
        <div style={{ overflowX: "auto" }}>
            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", padding: "10px" }}>
                <h5 >{name}</h5>


                {isLoading ? (
                    <button style={buttonStyle} disabled>
                        <span className="spinner" /> Downloading...
                    </button>
                ) : (
                    <button style={buttonStyle} onClick={() => downloadCsv(statusPayload)}>
                        Download
                    </button>
                )}
            </div>

            <div style={{ overflowX: "auto", maxWidth: '1300px', maxHeight: '500px', marginTop: '20px', padding: '0 10px' }}>
                {mode == 1 ? (
                    <table style={tableStyle}>
                        <thead>
                            <tr>
                                <th style={thStyle}>S.No</th>
                                <th style={thStyle}>Lead Number</th>
                                <th style={thStyle}>Client Code</th>
                                <th style={thStyle}>Bride Name</th>
                                <th style={thStyle}>Groom Name</th>
                                <th style={thStyle}>Event Name</th>
                                <th style={thStyle}>Event Date</th>
                                <th style={thStyle}>Pending Deliverable Count</th>
                                <th style={thStyle}>Pending Deliverable List</th>

                            </tr>
                        </thead>
                        <tbody>
                            {currentPageData &&
                                currentPageData.length > 0 ? (
                                currentPageData.map((item, index) => {
                                    const allEvents = item && item.allEvents && item.allEvents.length > 0 ? item.allEvents.map((m) =>
                                        m).join(",") : "--"
                                    const eventDate = item && item.eventDate && item.eventDate.length > 0 ?
                                        item.eventDate.map((m) => moment(m).format(dateFormat)).join(",") : "--"
                                    const pendingDelierables = item && item.pendingDelierables && item.pendingDelierables.length > 0 ?
                                        item.pendingDelierables.map(m => m).join(",") : "--"


                                    return (
                                        <>
                                            <tr key={index}>
                                                <td style={tdStyle}>{index + 1}</td>
                                                <td style={tdStyle}>{item.leadNo}</td>
                                                <td style={tdStyle}>{item.clientCode ? item.clientCode : "--"}</td>
                                                <td style={tdStyle}>{item.brideName ? item.brideName : "--"}</td>
                                                <td style={tdStyle}>{item.groomName ? item.groomName : "--"}</td>
                                                <td style={tdStyle}>{allEvents}</td>
                                                <td style={tdStyle}>{eventDate}</td>
                                                <td style={tdStyle}>{item.pendingDeliCount ? item.pendingDeliCount : "--"}</td>
                                                <td style={tdStyle}>{pendingDelierables}</td>

                                            </tr>
                                        </>
                                    )
                                })
                            ) : (
                                <>
                                    <tr key={0}>
                                        <td colSpan={9} style={{ ...tdStyle, textAlign: 'center' }}>
                                            No record found
                                        </td>
                                    </tr>
                                </>
                            )}


                        </tbody>
                    </table>) : mode == 2 || mode == 3 || mode == 4 || mode == 5 || mode == 6 || mode == 7 ?
                    (<table style={tableStyle}>
                        <thead>
                            <tr>
                                <th style={thStyle}>S.No</th>
                                <th style={thStyle}>Client Code</th>
                                <th style={thStyle}>Lead Number</th>
                                <th style={thStyle}>Bride Name</th>
                                <th style={thStyle}>Groom Name</th>
                                <th style={thStyle}>Event Name</th>
                                <th style={thStyle}>Event Date</th>
                                <th style={thStyle}>Pending Deliverable Count</th>
                                <th style={thStyle}>Pending Deliverable List</th>

                            </tr>
                        </thead>
                        <tbody>
                            {currentPageData &&
                                currentPageData.length > 0 ? (
                                currentPageData.map((item, index) => {
                                    const allEvents = item && item.allEvents && item.allEvents.length > 0 ? item.allEvents.map((m) =>
                                        m).join(",") : "--"
                                    const eventDate = item && item.eventDate && item.eventDate.length > 0 ?
                                        item.eventDate.map((m) => moment(m).format(dateFormat)).join(",") : "--"

                                    const leadNo = item && item.leadNo && item.leadNo.length > 0 ?
                                        item.leadNo.map(m => m).join(",") : "--"

                                    const pendingDelierables = item && item.pendingDelierables && item.pendingDelierables.length > 0 ?
                                        item.pendingDelierables.map(m => m).join(",") : "--"

                                    const brideName = item && item.brideName && item.brideName.length > 0 ?
                                        item.brideName.map(m => m).join(",") : "--"

                                    const groomName = item && item.groomName && item.groomName.length > 0 ?
                                        item.groomName.map(m => m).join(",") : "--"
                                    return (
                                        <>
                                            <tr key={index}>
                                                <td style={tdStyle}>{index + 1}</td>
                                                <td style={tdStyle}>{item.clientCode ? item.clientCode : "--"}</td>
                                                <td style={tdStyle}>{leadNo}</td>
                                                <td style={tdStyle}>{brideName}</td>
                                                <td style={tdStyle}>{groomName}</td>
                                                <td style={tdStyle}>{allEvents}</td>
                                                <td style={tdStyle}>{eventDate}</td>
                                                <td style={tdStyle}>{item.pendingDeliCount ? item.pendingDeliCount : "--"}</td>
                                                <td style={tdStyle}>{pendingDelierables}</td>

                                            </tr>
                                        </>
                                    )
                                })
                            ) : (
                                <>
                                    <tr key={0}>
                                        <td colSpan={9} style={{ ...tdStyle, textAlign: 'center' }}>
                                            No record found
                                        </td>
                                    </tr>
                                </>
                            )}


                        </tbody>
                    </table>) : (<table style={tableStyle}>
                        <thead>
                            <tr>
                                <th style={thStyle}>S.No</th>
                                <th style={thStyle}>Client Code</th>
                                <th style={thStyle}>Lead Number</th>
                                <th style={thStyle}>Bride Name</th>
                                <th style={thStyle}>Groom Name</th>
                                <th style={thStyle}>Event Name</th>
                                <th style={thStyle}>Event Date</th>
                                <th style={thStyle}>Pending Deliverable Count</th>
                                <th style={thStyle}>Pending Deliverable List</th>
                                <th style={thStyle}>Client Complete Date</th>

                            </tr>
                        </thead>
                        <tbody>
                            {currentPageData &&
                                currentPageData.length > 0 ? (
                                currentPageData.map((item, index) => {
                                    const allEvents = item && item.allEvents && item.allEvents.length > 0 ? item.allEvents.map((m) =>
                                        m).join(",") : "--"
                                    const eventDate = item && item.eventDate && item.eventDate.length > 0 ?
                                        item.eventDate.map((m) => moment(m).format(dateFormat)).join(",") : "--"

                                    const leadNo = item && item.leadNo && item.leadNo.length > 0 ?
                                        item.leadNo.map(m => m).join(",") : "--"

                                    const completedDate = item && item.completedDate && item.completedDate.length > 0 ?
                                        item.completedDate.map((m) => moment(m).format(dateFormat)).join(",") : "--"

                                    const pendingDelierables = item && item.pendingDelierables && item.pendingDelierables.length > 0 ?
                                        item.pendingDelierables.map(m => m).join(",") : "--"
                                    const brideName = item && item.brideName && item.brideName.length > 0 ?
                                        item.brideName.map(m => m).join(",") : "--"

                                    const groomName = item && item.groomName && item.groomName.length > 0 ?
                                        item.groomName.map(m => m).join(",") : "--"
                                    return (
                                        <>
                                            <tr key={index}>
                                                <td style={tdStyle}>{index + 1}</td>
                                                <td style={tdStyle}>{item.clientCode ? item.clientCode : "--"}</td>
                                                <td style={tdStyle}>{leadNo}</td>
                                                <td style={tdStyle}>{brideName}</td>
                                                <td style={tdStyle}>{groomName}</td>
                                                <td style={tdStyle}>{allEvents}</td>
                                                <td style={tdStyle}>{eventDate}</td>
                                                <td style={tdStyle}>{item.pendingDeliCount ? item.pendingDeliCount : "--"}</td>
                                                <td style={tdStyle}>{pendingDelierables}</td>
                                                <td style={tdStyle}>{completedDate}</td>

                                            </tr>
                                        </>
                                    )
                                })
                            ) : (
                                <>
                                    <tr key={0}>
                                        <td colSpan={9} style={{ ...tdStyle, textAlign: 'center' }}>
                                            No record found
                                        </td>
                                    </tr>
                                </>
                            )}


                        </tbody>
                    </table>)
                }



            </div>
            <div className="pagination" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '10px', }}>
                {/* Showing rows information */}
                <p style={{ margin: '0', float: "left" }}>
                    Showing rows {currentPageData.length > 0 ? (startIndex + 1) : 0} to {Math.min(endIndex, data.length)} of {data.length}
                </p>
                {/* Pagination buttons */}
                <div style={{ float: "right" }}>
                    <button
                        style={{ backgroundColor: '#FFFFFF', color: '#74788D', border: '1px solid #74788D', padding: '5px 10px', marginRight: '5px', cursor: 'pointer' }}
                        onClick={() => handlePageChange(currentPage - 1)}
                        disabled={currentPage === 1}
                    >
                        Prev
                    </button>
                    {renderPaginationButtons()}
                    <button
                        style={{ backgroundColor: '#FFFFFF', color: '#74788D', border: '1px solid #74788D', padding: '5px 10px', marginRight: '5px', cursor: 'pointer' }}
                        onClick={() => handlePageChange(currentPage + 1)}
                        disabled={currentPage === totalPages}
                    >
                        Next
                    </button>
                </div>
            </div>
        </div>

    )
}

MonthWiseTableComponent.propTypes = {
    data: PropTypes.array.isRequired,
    dispatch: PropTypes.func.isRequired,
    statusPayload: PropTypes.object.isRequired,
    name: PropTypes.string.isRequired,
    mode: PropTypes.number,
    dateFormat: PropTypes.string
}

export default MonthWiseTableComponent

